const data = {
  title: "Floor 3-9",
  musicTrack: "MUSIC_BATTLE",
  story: "Ciabatta appears! He is angry.",
  theme: "PINK",
  tilesWidth: 13,
  tilesHeight: 13,
  placements: [
    {
      type: "HERO_SPAWN",
      x: 7,
      y: 4
    },
    {
      type: "PLACEMENT_TYPE_GOAL",
      x: 7,
      y: 10
    },
    {
      type: "ICE",
      x: 5,
      y: 9
    },
    {
      type: "ICE",
      x: 6,
      y: 12
    },
    {
      type: "ICE",
      x: 7,
      y: 11
    },
    {
      type: "ICE",
      x: 7,
      y: 12
    },
    {
      type: "ICE",
      x: 9,
      y: 11
    },
    {
      type: "ICE",
      x: 8,
      y: 9
    },
    {
      type: "ICE",
      x: 5,
      y: 8
    },
    {
      type: "ICE",
      x: 6,
      y: 11
    },
    {
      type: "ICE",
      x: 6,
      y: 9
    },
    {
      type: "ICE",
      x: 8,
      y: 10
    },
    {
      type: "ICE",
      x: 8,
      y: 11
    },
    {
      type: "ICE",
      x: 7,
      y: 9
    },
    {
      type: "ICE",
      x: 5,
      y: 10
    },
    {
      type: "ENEMY_SPAWN",
      x: 7,
      y: 1,
      enemyType: "CIABATTA"
    },
    {
      type: "KEY",
      x: 12,
      y: 4,
      color: "GREEN"
    },
    {
      type: "ICE",
      x: 5,
      y: 7
    },
    {
      type: "ICE",
      x: 6,
      y: 8
    },
    {
      type: "ICE",
      x: 6,
      y: 7
    },
    {
      type: "ICE",
      x: 7,
      y: 8
    },
    {
      type: "ICE",
      x: 7,
      y: 7
    },
    {
      type: "ICE",
      x: 8,
      y: 7
    },
    {
      type: "ICE",
      x: 8,
      y: 8
    },
    {
      type: "ICE",
      x: 9,
      y: 7
    },
    {
      type: "ICE",
      x: 9,
      y: 8
    },
    {
      type: "SWITCH",
      x: 4,
      y: 1
    },
    {
      type: "SWITCH",
      x: 10,
      y: 1
    },
    {
      type: "ICE",
      x: 6,
      y: 10
    },
    {
      type: "ICE",
      x: 9,
      y: 9
    },
    {
      type: "ICE",
      x: 8,
      y: 12
    },
    {
      type: "ICE",
      x: 9,
      y: 10
    },
    {
      type: "FIRE",
      x: 4,
      y: 13
    },
    {
      type: "FIRE",
      x: 5,
      y: 13
    },
    {
      type: "FIRE",
      x: 6,
      y: 13
    },
    {
      type: "FIRE",
      x: 8,
      y: 13
    },
    {
      type: "FIRE",
      x: 9,
      y: 13
    },
    {
      type: "FIRE",
      x: 10,
      y: 13
    },
    {
      type: "FIRE",
      x: 10,
      y: 12
    },
    {
      type: "FIRE",
      x: 10,
      y: 11
    },
    {
      type: "FIRE",
      x: 4,
      y: 11
    },
    {
      type: "FIRE",
      x: 4,
      y: 12
    },
    {
      type: "FIRE",
      x: 11,
      y: 10
    },
    {
      type: "FIRE",
      x: 2,
      y: 10
    },
    {
      type: "FIRE",
      x: 3,
      y: 10
    },
    {
      type: "ICE",
      x: 1,
      y: 11
    },
    {
      type: "ICE",
      x: 1,
      y: 12
    },
    {
      type: "ICE",
      x: 2,
      y: 12
    },
    {
      type: "ICE",
      x: 2,
      y: 11
    },
    {
      type: "ICE",
      x: 2,
      y: 13
    },
    {
      type: "ICE",
      x: 3,
      y: 13
    },
    {
      type: "ICE",
      x: 3,
      y: 11
    },
    {
      type: "ICE",
      x: 3,
      y: 12
    },
    {
      type: "ICE",
      x: 5,
      y: 11
    },
    {
      type: "WATER",
      x: 1,
      y: 9
    },
    {
      type: "WATER",
      x: 2,
      y: 9
    },
    {
      type: "WATER",
      x: 3,
      y: 9
    },
    {
      type: "WATER",
      x: 3,
      y: 8
    },
    {
      type: "WATER",
      x: 3,
      y: 7
    },
    {
      type: "WATER",
      x: 2,
      y: 7
    },
    {
      type: "WATER",
      x: 1,
      y: 7
    },
    {
      type: "WATER",
      x: 1,
      y: 8
    },
    {
      type: "WATER",
      x: 2,
      y: 8
    },
    {
      type: "SWITCH_WALL",
      x: 7,
      y: 13,
      isRaised: true
    },
    {
      type: "FIRE_BOOTS",
      x: 7,
      y: 8
    },
    {
      type: "ICE",
      x: 11,
      y: 13
    },
    {
      type: "ICE",
      x: 11,
      y: 12
    },
    {
      type: "ICE",
      x: 11,
      y: 11
    },
    {
      type: "ICE",
      x: 12,
      y: 13
    },
    {
      type: "ICE",
      x: 12,
      y: 12
    },
    {
      type: "ICE",
      x: 12,
      y: 11
    },
    {
      type: "ICE",
      x: 13,
      y: 12
    },
    {
      type: "ICE",
      x: 13,
      y: 11
    },
    {
      type: "ICE",
      x: 11,
      y: 5
    },
    {
      type: "ICE",
      x: 11,
      y: 4
    },
    {
      type: "ICE",
      x: 12,
      y: 4
    },
    {
      type: "ICE",
      x: 13,
      y: 4
    },
    {
      type: "ICE",
      x: 12,
      y: 5
    },
    {
      type: "ICE",
      x: 3,
      y: 3
    },
    {
      type: "ICE",
      x: 2,
      y: 3
    },
    {
      type: "ICE",
      x: 1,
      y: 4
    },
    {
      type: "ICE",
      x: 2,
      y: 5
    },
    {
      type: "ICE",
      x: 2,
      y: 4
    },
    {
      type: "LOCK",
      x: 10,
      y: 10,
      color: "GREEN"
    },
    {
      type: "LOCK",
      x: 4,
      y: 10,
      color: "BLUE"
    },
    {
      type: "KEY",
      x: 2,
      y: 4,
      color: "BLUE"
    },
    {
      type: "ICE",
      x: 9,
      y: 12,
      corner: "BOTTOM_RIGHT"
    },
    {
      type: "ICE",
      x: 5,
      y: 12,
      corner: "BOTTOM_LEFT"
    },
    {
      type: "WATER",
      x: 12,
      y: 8
    },
    {
      type: "WATER",
      x: 13,
      y: 8
    },
    {
      type: "WATER",
      x: 11,
      y: 8
    },
    {
      type: "WATER",
      x: 11,
      y: 9
    },
    {
      type: "WATER",
      x: 12,
      y: 9
    },
    {
      type: "WATER",
      x: 13,
      y: 9
    },
    {
      type: "CHIP",
      x: 12,
      y: 8
    },
    {
      type: "CHIP",
      x: 12,
      y: 12
    },
    {
      type: "CHIP",
      x: 2,
      y: 8
    },
    {
      type: "CHIP",
      x: 2,
      y: 12
    },
    {
      type: "ICE",
      x: 13,
      y: 13,
      corner: "BOTTOM_RIGHT"
    },
    {
      type: "ICE",
      x: 1,
      y: 13,
      corner: "BOTTOM_LEFT"
    },
    {
      type: "FIRE",
      x: 12,
      y: 10
    },
    {
      type: "WATER_PICKUP",
      x: 1,
      y: 13
    },
    {
      type: "ICE",
      x: 4,
      y: 5
    },
    {
      type: "ICE",
      x: 4,
      y: 3
    },
    {
      type: "ICE",
      x: 10,
      y: 5
    },
    {
      type: "ICE",
      x: 1,
      y: 3,
      corner: "TOP_LEFT"
    },
    {
      type: "WALL",
      x: 1,
      y: 2
    },
    {
      type: "WALL",
      x: 2,
      y: 2
    },
    {
      type: "WALL",
      x: 4,
      y: 2
    },
    {
      type: "WALL",
      x: 3,
      y: 2
    },
    {
      type: "WALL",
      x: 5,
      y: 2
    },
    {
      type: "WALL",
      x: 6,
      y: 2
    },
    {
      type: "WALL",
      x: 7,
      y: 2
    },
    {
      type: "WALL",
      x: 8,
      y: 2
    },
    {
      type: "WALL",
      x: 9,
      y: 2
    },
    {
      type: "WALL",
      x: 11,
      y: 2
    },
    {
      type: "WALL",
      x: 10,
      y: 2
    },
    {
      type: "WALL",
      x: 12,
      y: 2
    },
    {
      type: "WALL",
      x: 13,
      y: 2
    },
    {
      type: "THIEF",
      x: 13,
      y: 10
    },
    {
      type: "THIEF",
      x: 1,
      y: 10
    },
    {
      type: "ICE",
      x: 10,
      y: 8
    },
    {
      type: "ICE",
      x: 4,
      y: 8
    },
    {
      type: "WATER",
      x: 11,
      y: 7
    },
    {
      type: "WATER",
      x: 12,
      y: 7
    },
    {
      type: "WATER",
      x: 13,
      y: 7
    },
    {
      type: "WATER",
      x: 3,
      y: 5
    },
    {
      type: "ICE",
      x: 4,
      y: 9,
      corner: "BOTTOM_LEFT"
    },
    {
      type: "ICE",
      x: 10,
      y: 7,
      corner: "TOP_RIGHT"
    },
    {
      type: "SWITCH_WALL",
      x: 7,
      y: 6,
      isRaised: true
    },
    {
      type: "ICE",
      x: 3,
      y: 4
    },
    {
      type: "CONVEYOR",
      x: 4,
      y: 4,
      direction: "LEFT"
    },
    {
      type: "CONVEYOR",
      x: 10,
      y: 4,
      direction: "RIGHT"
    },
    {
      type: "WATER",
      x: 11,
      y: 3
    },
    {
      type: "ICE",
      x: 13,
      y: 3,
      corner: "TOP_RIGHT"
    },
    {
      type: "ICE",
      x: 10,
      y: 3
    },
    {
      type: "ICE",
      x: 12,
      y: 3
    },
    {
      type: "ICE",
      x: 1,
      y: 5,
      corner: "BOTTOM_LEFT"
    },
    {
      type: "ICE",
      x: 13,
      y: 5,
      corner: "BOTTOM_RIGHT"
    },
    {
      type: "WALL",
      x: 13,
      y: 6
    },
    {
      type: "WALL",
      x: 12,
      y: 6
    },
    {
      type: "WALL",
      x: 10,
      y: 6
    },
    {
      type: "WALL",
      x: 11,
      y: 6
    },
    {
      type: "WALL",
      x: 1,
      y: 6
    },
    {
      type: "WALL",
      x: 2,
      y: 6
    },
    {
      type: "WALL",
      x: 3,
      y: 6
    },
    {
      type: "WALL",
      x: 4,
      y: 6
    },
    {
      type: "SWITCH_WALL",
      x: 5,
      y: 6,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 6,
      y: 6,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 8,
      y: 6,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 9,
      y: 6,
      isRaised: true
    },
    {
      type: "ICE",
      x: 10,
      y: 9
    },
    {
      type: "ICE",
      x: 4,
      y: 7
    }
  ]
};

export default data;
